// IE 2026 10 14 / ODOO-5800 (app7 #84472, бой ev33, срез 1coh_001 Pimafucin №3 — 20 375 строк: клик ✓PM документа — DOM через 3,4 с, Ctrl+Z — 4,8 с; CDP-профиль dev02 pfperf3:
// 2,7 с из 3,4 с клика и 2,6 с из 4,4 с отката — alertChild_map: после правки ОДНОЙ ячейки карта «потомок → цвет ближайшего alert-предка» сбрасывалась целиком
// (_alertKids = null) и на первом же formatItem перестраивалась ПОЛНЫМ обходом 20 тыс. строк данных с cf_compute по каждой (правила оформления, кэш только что
// очищен) — при том что alert-строк в отчёте ноль и карта пуста). Теперь карта обновляется точечно: статус alert-строки зависит от её полей (alert, measure,
// классы правил по своей строке и, при наследовании, по предкам) — после правки строки заново оцениваются только она и её предки (цепочка к корню); статус
// ни у кого не изменился и у правленой строки нет потомков — карта как была; изменился — заново обходится поддерево САМОГО ВЕРХНЕГО изменившегося узла
// (с унаследованным сверху цветом), остальные ветви не трогаются. Выключатель fe.ux.alertChildKeep (дефолт ВКЛ; false — прежний полный сброс).
// Тест — tests/unit/alertChildKeep.test.mjs
export const ALERT_CHILD_KEEP_FLAG = 'fe.ux.alertChildKeep'

export function alertChildKeep_flagOn(setting) {
    try { return typeof setting === 'function' ? setting(ALERT_CHILD_KEEP_FLAG, true) !== false : true } catch (e) { return true }
}

// цвета равны (null/undefined — «не alert-строка»)
export function alertColor_same(a, b) {
    if (!a && !b) return true
    if (!a || !b) return false
    return a.r === b.r && a.g === b.g && a.b === b.b && (a.a ?? 1) === (b.a ?? 1)
}

// полный обход поддеревьев arr с унаследованным цветом color: map — «потомок → цвет ближайшего alert-предка» (только строки НЕ alert под alert-предком),
// own — «строка → её собственный цвет alert-строки либо null» (мемо для точечного обновления), parent — «строка → родитель» (цепочка к корню)
// ownOf(item) — цвет alert-строки (alert_isRow ? alertRow_color : null)
export function alertChild_walk(arr, color, kidsKey, ownOf, S) {
    const { map, own, parent } = S
    const stack = []
    for (let i = (arr || []).length - 1; i >= 0; i--) stack.push([arr[i], color, null])
    let n = 0
    while (stack.length) {
        const [it, col, par] = stack.pop()
        if (!it || typeof it !== 'object') continue
        n++
        const o = ownOf(it) || null
        own.set(it, o)
        if (par) parent.set(it, par)
        if (!o && col) map.set(it, col); else map.delete(it)
        const ch = it[kidsKey]
        if (Array.isArray(ch) && ch.length) { const c = o || col; for (let i = ch.length - 1; i >= 0; i--) stack.push([ch[i], c, it]) }
    }
    return n
}

export function alertChild_build(data, kidsKey, ownOf) {
    const S = { map: new Map(), own: new Map(), parent: new Map() }
    S.n = alertChild_walk(data, null, kidsKey, ownOf, S)
    return S
}

// цепочка «корень … item» по карте родителей (null — строки в карте нет: новая строка / чужой набор — нужен полный сброс)
export function alertChild_chain(S, item) {
    if (!S || !S.own.has(item)) return null
    const chain = [item]
    let cur = item, guard = 0
    while (guard++ < 64) { const p = S.parent.get(cur); if (!p) break; chain.push(p); cur = p }
    if (guard >= 64) return null
    return chain.reverse()
}

// точечное обновление после правки строки item. Возврат: число заново обойдённых строк (0 — карта не изменилась), -1 — обновить нельзя (вызывающий сбрасывает карту)
export function alertChild_update(S, item, kidsKey, ownOf) {
    const chain = alertChild_chain(S, item)
    if (!chain) return -1
    let idx = -1
    for (let i = 0; i < chain.length; i++) {
        const o = ownOf(chain[i]) || null
        if (!alertColor_same(o, S.own.get(chain[i]))) { idx = i; break }
    }
    const kids = item[kidsKey]
    const hasKids = Array.isArray(kids) && kids.length > 0
    if (idx < 0) {
        if (!hasKids) return 0
        idx = chain.length - 1   // потомки правленой строки могли сменить статус (наследуемые поля) — её поддерево заново
    }
    const node = chain[idx]
    let above = null
    for (let j = 0; j < idx; j++) { const o = S.own.get(chain[j]); if (o) above = o }
    // старые записи поддерева — долой (строки, выбывшие из-под alert-предка)
    const stack = [node]
    while (stack.length) {
        const it = stack.pop()
        if (!it || typeof it !== 'object') continue
        S.map.delete(it)
        const ch = it[kidsKey]
        if (Array.isArray(ch)) for (const c of ch) stack.push(c)
    }
    const par = S.parent.get(node) || null
    const n = alertChild_walk([node], above, kidsKey, ownOf, S)
    if (par) S.parent.set(node, par)
    return n
}
